import { render, staticRenderFns } from "./ztBreadcrumbs.vue?vue&type=template&id=44125c74&"
import script from "./ztBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./ztBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../admin/public/onboarding/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports